import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: false,
  all: []
};

export const { actions: activityTypeActions, reducer: activityTypeReducer } = createSlice({
  name: 'activityType',
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error, action;
    },
    getActivityTypesAll(state) {
      state.loading = true;
    },
    getActivityTypesAllFulfilled(state, action) {
      state.all = action.payload.sort((a, b) => a.name.localeCompare(b.name));
    },
    postActivityType(state) {
      state.loading = true;
    },
    postActivityTypeFulfilled(state, action) {
      state.all = [...state.all, action.payload].sort((a, b) => a.name.localeCompare(b.name));
    },
    patchActivityType(state) {
      state.loading = true;
    },
    patchActivityTypeFulfilled(state, action) {
      const arr = [...state.all];
      const foundIndex = arr.findIndex((item) => item.id === action.payload.id);
      arr.splice(foundIndex, 1, action.payload);
      state.all = arr;
    },
    deleteActivityType(state) {
      state.loading = true;
    },
    deleteActivityTypeFulfilled(state, action) {
      state.all = state.all.filter((d) => d.id !== action.payload);
    }
  }
});
